module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isLogged) ? _c('header', {
    staticClass: "ls-topbar"
  }, [(!_vm.popup) ? _c('div', {
    staticClass: "ls-notification-topbar"
  }, [_c('div', {
    staticClass: "ls-alerts-list",
    attrs: {
      "role": "alert"
    }
  }, [_c('a', {
    staticClass: "ls-ico-cart",
    attrs: {
      "href": _vm.linkPlans,
      "target": "_blank"
    }
  })]), _vm._v(" "), _c('dropdown', {
    class: 'ls-dropdown ls-user-account'
  }, [_c('a', {
    staticClass: "ls-ico-user",
    attrs: {
      "href": "javascript:void(0)"
    },
    slot: "trigger"
  }, [_c('span', {
    staticClass: "ls-name"
  }, [_vm._v(_vm._s(_vm.seller.name))]), _vm._v("\n      (" + _vm._s(_vm.seller.email) + ")\n      ")]), _vm._v(" "), _c('nav', {
    staticClass: "ls-dropdown-nav ls-user-menu",
    attrs: {
      "aria-hidden": "true"
    },
    slot: "list"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)",
      "role": "option"
    },
    on: {
      "click": _vm.logOut
    }
  }, [_vm._v(_vm._s(_vm.$t('application.menu_user.logout')))])])])])])], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "ls-show-sidebar ls-ico-menu",
    on: {
      "click": _vm.toggleSidebar
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "ls-brand-name"
  }, [_c('router-link', {
    staticClass: "ls-display-inline-block",
    attrs: {
      "to": "/"
    }
  }, [_c('div', {
    staticClass: "ls-display-inline-block"
  }, [_c('small', [_vm._v(_vm._s(_vm.$t('application.header.subscriptions_traycheckout')))]), _vm._v(" " + _vm._s(_vm.seller.trade_name) + "\n      ")])])], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e6d4f4a2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/layouts/components/header/main.vue
// module id = 839
// module chunks = 1